import { motion } from "framer-motion";

// Shared scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Section overline label
export const Overline = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-3 text-xs md:text-sm uppercase tracking-[0.25em] text-brand-orange font-bold ${className}`}>
    <span className="h-px w-8 bg-brand-orange/60" aria-hidden />
    {children}
  </span>
);

// Masked line-by-line reveal for headings
export const MaskedLines = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export default Reveal;
